import { FlParams } from '@yme/utils/bloomreach';
export const PRODUCT_FL_PARAMS = [
    FlParams.PID,
    FlParams.TITLE,
    FlParams.URL,
    FlParams.PRIMARY_TYPE,
    FlParams.THUMB_IMAGE,
    FlParams.PRICE_VARIANT,
    FlParams.SALE_PRICE_VARIANT,
    FlParams.DRIVER_LICENCE,
    FlParams.IS_ELECTRIC,
    FlParams.CURRENCY_CODE,
    FlParams.PRODUCT_YEAR,
    FlParams.IS_LATEST_MODEL,
    FlParams.PRICE_TOOLTIP_TEXT,
    FlParams.EMBARGO_EXTERNAL_DATE,
    FlParams.SKU,
    FlParams.IS_DISCOUNTED,
    FlParams.IS_YMT,
    FlParams.IS_NEW,
    FlParams.COLOR,
    FlParams.TYPE_EN,
    FlParams.VARIANT_ID,
    FlParams.SIZE,
    FlParams.ANALYTICS_CATEGORIES,
];
export const CONTENT_FL_PARAMS = [
    FlParams.ITEM_ID,
    FlParams.TITLE,
    FlParams.URL,
    FlParams.DESCRIPTION,
    FlParams.DATE,
    FlParams.DATE_TO,
    FlParams.PRIMARY_TYPE,
];
export const SearchSortingValues = {
    SORT_PRICE_ASC: 'from_price asc',
    SORT_PRICE_DESC: 'from_price desc',
    SORT_ASC: 'embargo_external_date asc',
    SORT_DESC: 'embargo_external_date desc',
    SORT_RECOMMENDED: 'relevance asc',
    SORT_DEFAULT: 'default',
};
